import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { cva } from "class-variance-authority";
import { forwardRef } from "react";
const menuVariants = cva("z-50 mt-2 w-full rounded-md border border-none bg-white py-2 shadow-sm overflow-auto pr-[1px]");
const menuContentVariants = cva("custom-scrollbar overflow-y-auto pr-[1px]");
const menuItemVariants = cva([
    "flex cursor-pointer select-none items-center px-3 py-2 text-sm outline-none transition-colors",
    "hover:bg-gray-300/20"
], {
    variants: {
        typo: {
            body1: "typo-body1 p-3",
            body2: "typo-body2 px-3 py-2"
        },
        selected: {
            true: "bg-gray-100 text-primary-main",
            false: "text-gray-900"
        },
        disabled: {
            true: "pointer-events-none text-muted",
            false: ""
        },
        divider: {
            true: 'relative after:content-[""] after:absolute after:left-0 after:right-0 after:bottom-0 after:h-px after:bg-gray-100'
        }
    },
    defaultVariants: {
        selected: false,
        disabled: false
    }
});
const Menu = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { classes , items , selectedValue , onChange , ...props } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: cn(menuVariants(), classes === null || classes === void 0 ? void 0 : classes.root),
        ...props,
        ref: ref,
        children: /*#__PURE__*/ _jsx("ul", {
            className: cn(menuContentVariants(), classes === null || classes === void 0 ? void 0 : classes.content),
            children: items.map((item, index)=>{
                /*#__PURE__*/ return _jsx("li", {
                    className: cn(menuItemVariants({
                        typo: undefined,
                        selected: selectedValue === item.value,
                        disabled: item.disabled,
                        divider: false
                    }), classes === null || classes === void 0 ? void 0 : classes.item),
                    onClick: ()=>{
                        if (!item.disabled) {
                            onChange === null || onChange === void 0 ? void 0 : onChange(item.value);
                        }
                    },
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "flex items-center gap-3",
                        children: /*#__PURE__*/ _jsx("span", {
                            className: "flex-1",
                            children: item.label
                        })
                    })
                }, index);
            })
        })
    });
});
export default Menu;
